/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SiteNav_viewer = {|
  +showFullWidthNav: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNav_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "showFullWidthNav",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "showFullWidthNav",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"showFullWidthNav\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
